import theme from "../../theme";

export const LinkContainer = {
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    cursor: "pointer",
};
